const GENERICA = 'Não foi possível concluir. Tente de novo; se persistir, veja a trilha de auditoria.'
const PROVISIONER =
  'A infraestrutura de segredos do SSO ainda não está configurada. Os dados ficaram salvos como rascunho.'
const TRANSICAO = 'Transição de estado não permitida'

// Um código por HTTPException do bloco SSO de api.py / sso_service.py.
const CONHECIDAS: Record<string, { message: string; field?: string }> = {
  sso_disabled: { message: 'Gateway SSO desligado neste ambiente' },
  sso_provisioner_not_configured: { message: PROVISIONER },
  sso_provisioner_unavailable: { message: PROVISIONER },
  sso_keycloak_unavailable: { message: 'Keycloak indisponível; tente de novo' },
  realm_owned_by_other_tenant: { message: 'Este realm pertence a outro tenant.' },
  sso_realm_has_entra_connection: { message: 'Este realm já tem um provedor Entra. Use Trocar tenant/client/secret.' },
  sso_activate_via_provision: { message: 'Ative pelo botão Reprovisionar.' },
  connection_not_updatable_in_paused: { message: 'Reative o provedor antes de alterar' },
  connection_secret_missing: { message: 'Grave o client secret do Entra (Trocar tenant/client/secret)', field: 'client_secret' },
  application_not_provisionable: { message: 'Esta aplicação não pode ser provisionada agora.' },
  sso_application_paused: { message: 'Reative o app antes de reprovisionar' },
  sso_application_invalid_transition: { message: TRANSICAO },
  client_secret_required: { message: 'Informe o client secret do Entra.', field: 'client_secret' },
  client_secret_requires_entra_id_with_realm: {
    message: 'O client secret só vale para provedor Entra com realm.', field: 'client_secret' },
  client_secret_only_on_entra_reprovision: {
    message: 'O client secret só é aceito ao reprovisionar um provedor Entra.', field: 'client_secret' },
  sso_update_empty: { message: 'Informe ao menos um campo para alterar.' },
  integrity_conflict: { message: 'Já existe um registro com estes dados.' },
}

// Código cru do backend (snake_case sem espaço): nunca vai para a tela.
const CODIGO_CRU = /^[a-z0-9_:]+$/

export function ssoErrorMessage(err: unknown): { message: string; field?: string } {
  const resp = (err as { response?: { status?: number; data?: { detail?: unknown } } } | null)?.response
  const status = resp?.status
  const detail = resp?.data?.detail
  if (typeof detail === 'string') {
    if (detail in CONHECIDAS) return { ...CONHECIDAS[detail] }
    if (detail.startsWith('principal consumidor fora da allowlist')) {
      return {
        message: 'Esta conta AWS não está autorizada a ler segredos do SSO. Peça a inclusão dela na allowlist.',
        field: 'secret_consumer_principal',
      }
    }
    if (detail.startsWith('papel padrão inválido') || detail.includes('provedor Entra ativo')) {
      return { message: detail, field: 'default_role' }
    }
    if (status === 404) return { message: 'Registro não encontrado' }
    if (detail.includes('->')) return { message: TRANSICAO }
    // Texto livre em português (DeleteBlocked, InvalidSsoInput, dono do realm) passa;
    // código desconhecido não.
    if ((status === 409 || status === 422) && !CODIGO_CRU.test(detail)) return { message: detail }
  }
  if (status === 422 && Array.isArray(detail) && detail.length > 0) {
    const first = detail[0] as { loc?: unknown[]; msg?: string }
    const field = first.loc?.length ? String(first.loc[first.loc.length - 1]) : undefined
    if (first.msg) return field ? { message: first.msg, field } : { message: first.msg }
  }
  return { message: GENERICA }
}
